import { render, staticRenderFns } from "./PrivateSpace.vue?vue&type=template&id=2eed54f8"
import script from "./PrivateSpace.vue?vue&type=script&lang=js"
export * from "./PrivateSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports